import { API_BASE_URL } from './prospects';

function authHeaders() {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function buildQuery(params) {
  const q = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    q.set(key, String(value));
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

export async function fetchAdminSalesChart(month) {
  const res = await fetch(
    `${API_BASE_URL}/admin/sales/chart${buildQuery({ month })}`,
    { headers: { ...authHeaders() } },
  );
  const body = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(body?.data?.message || 'Impossible de charger le graphique.');
  }
  return body;
}

export async function fetchAdminSales(params = {}) {
  const res = await fetch(
    `${API_BASE_URL}/admin/sales${buildQuery(params)}`,
    { headers: { ...authHeaders() } },
  );
  const body = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(body?.data?.message || 'Impossible de charger les ventes.');
  }
  return body;
}

export async function downloadAdminSalesCsv(params = {}) {
  const res = await fetch(
    `${API_BASE_URL}/admin/sales/export${buildQuery(params)}`,
    { headers: { ...authHeaders() } },
  );
  if (!res.ok) {
    const body = await res.json().catch(() => null);
    throw new Error(body?.data?.message || 'Export CSV impossible.');
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `ventes-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function currentMonthKey() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}
